<script lang="ts">
  import { starIcon, starSolidIcon } from '@nrk/core-icons';
  interface Props {
    active?: boolean;
  }
  let { active }: Props = $props();
</script>

{#if active}
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html starSolidIcon}
{:else}
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html starIcon}
{/if}
